import { render, staticRenderFns } from "./SkipToMain.vue?vue&type=template&id=6303cb56&scoped=true"
import script from "./SkipToMain.vue?vue&type=script&lang=js"
export * from "./SkipToMain.vue?vue&type=script&lang=js"
import style0 from "./SkipToMain.vue?vue&type=style&index=0&id=6303cb56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303cb56",
  null
  
)

export default component.exports